import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import * as fromPlantsAction from '@ordersnproducts/modules/new-modify-order/modules/new-modify-product-specification/actions/plants.action';
import { Plant } from '@cemex-core/cmx-api';

export interface State extends EntityState<Plant> {
  selectedPlantId: number | null;
}

export const adapter: EntityAdapter<Plant> = createEntityAdapter<Plant>({
  selectId: ($plant: Plant) => $plant['sateId'],
  sortComparer: false,
});

const initialState: State = adapter.getInitialState({
  selectedPlantId: null,
});

export function reducer(state = initialState, action: fromPlantsAction.Actions): State {
  switch (action.type) {
    case fromPlantsAction.ActionTypes.ADD_PLANTS: {
      return adapter.addMany(action.payload.plants, { ...state });
    }
    case fromPlantsAction.ActionTypes.CLEAR_PLANTS: {
      return adapter.removeAll(state);
    }
    case fromPlantsAction.ActionTypes.FETCH_PLANTS:
    default: {
      return state;
    }
  }
}

export const getEntities = (state: State) => state.entities;

export const getPlants = (state: State) => {
  const plants: Plant[] = Object.keys(state.entities).map(i => state.entities[i]);
  return plants;
};
